import { PageHead } from "./PageHead";

interface OrganizationSEOProps {
  title: string;
  description: string;
  canonical: string;
  ogImage?: string;
  keywords?: string;
}

export function OrganizationSEO({
  title,
  description,
  canonical,
  ogImage,
  keywords
}: OrganizationSEOProps) {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Cosmos Wave",
    "alternateName": "Cosmos Wave - Agence Amazon SPN",
    "url": "https://www.cosmos-wave.com",
    "logo": "https://www.cosmos-wave.com/favicon.png",
    "image": "https://www.cosmos-wave.com/og-home.jpg",
    "description": "Agence Amazon partenaire SPN spécialisée dans la stratégie e-commerce Amazon, l'optimisation des fiches produits, Amazon Ads et la créativité de marque.",
    "foundingDate": "2021",
    "slogan": "Expert Amazon & Creative Strategy",
    "knowsAbout": [
      "Amazon Marketing",
      "Amazon Ads",
      "Amazon SEO", 
      "E-commerce Strategy",
      "Digital Marketing",
      "Amazon SPN",
      "A+ Content",
      "Amazon Store Design"
    ],
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": 48.8566,
        "longitude": 2.3522
      },
      "geoRadius": "500000"
    },
    "contactPoint": [{
      "@type": "ContactPoint",
      "contactType": "sales",
      "email": "contact@cosmos-wave.com",
      "areaServed": "FR",
      "availableLanguage": ["French", "English"]
    }],
    "sameAs": [
      "https://www.linkedin.com/company/cosmoswave"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services Amazon",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Amazon Ads Management",
            "description": "Gestion complète des campagnes Amazon Ads (SP/SB/SD/DSP)"
          }
        },
        {
          "@type": "Offer", 
          "itemOffered": {
            "@type": "Service",
            "name": "Amazon SEO & Optimization",
            "description": "Optimisation des fiches produits et SEO Amazon"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service", 
            "name": "Creative Strategy",
            "description": "A+ Content, Amazon Store Design et stratégie créative"
          }
        }
      ]
    }
  };

  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Cosmos Wave",
    "alternateName": "Agence Amazon SPN",
    "url": "https://www.cosmos-wave.com",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.cosmos-wave.com/search?q={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    },
    "publisher": {
      "@id": "https://www.cosmos-wave.com#organization"
    }
  };

  return (
    <PageHead
      title={title}
      description={description}
      canonical={canonical}
      ogImage={ogImage}
      keywords={keywords}
      pageType="website"
      structuredData={[organizationSchema, webSiteSchema]}
    />
  );
}